import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { GET_CART } from 'mocks/queries';
import getZipcode from 'commons/getZipcode';
const useCartAndToken = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fetchPolicy: "cache-and-network",
      variables: {
        zipCode: getZipcode()
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    refetch
  } = useQuery(GET_CART, t0);
  const cart = data?.getCart?.cart;
  const token = data?.getCart?.cart_token;
  let t1;
  if ($[1] !== cart || $[2] !== refetch || $[3] !== token) {
    t1 = {
      cart,
      refetch,
      token
    };
    $[1] = cart;
    $[2] = refetch;
    $[3] = token;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default useCartAndToken;